<script>
  export let videoSRC;
</script>

<div class="responsive-iframe-container">
    <iframe width="560" height="315" src="{videoSRC}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
</div>

<style>
.responsive-iframe-container {
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* Aspect Ratio 16:9 (divide 9 by 16 and multiply by 100%) */
    margin: 0 auto;
}

.responsive-iframe-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>